module.exports = __webpack_public_path__ + "static/media/leftPurpleIcon.78f126ac.png";